export default __webpack_public_path__ + "static/media/time-was.65785cf1.webp";